import { render, staticRenderFns } from "./SectionTable.vue?vue&type=template&id=998921a6&"
import script from "./SectionTable.vue?vue&type=script&lang=js&"
export * from "./SectionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('998921a6')) {
      api.createRecord('998921a6', component.options)
    } else {
      api.reload('998921a6', component.options)
    }
    module.hot.accept("./SectionTable.vue?vue&type=template&id=998921a6&", function () {
      api.rerender('998921a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/FormBuilder/SectionTable.vue"
export default component.exports